"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardLinkedOfferPurchaseChannel = exports.CardLinkedOfferUserRewardType = exports.CardLinkedOfferCategory = void 0;
// Kard's categories: https://docs.getkard.com/2024-10-01/api/eligibility/get-offers-by-user#request.query.filter[category].filter[category]
var CardLinkedOfferCategory;
(function (CardLinkedOfferCategory) {
    CardLinkedOfferCategory["ARTS_ENTERTAINMENT"] = "Arts & Entertainment";
    CardLinkedOfferCategory["BABY_KIDS_TOYS"] = "Baby, Kids & Toys";
    CardLinkedOfferCategory["BOOKS_DIGITAL_MEDIA"] = "Books & Digital Media";
    CardLinkedOfferCategory["CLOTHING_SHOES_ACCESSORIES"] = "Clothing, Shoes & Accessories";
    CardLinkedOfferCategory["COMPUTERS_ELECTRONICS_SOFTWARE"] = "Computers, Electronics & Software";
    CardLinkedOfferCategory["CONVENIENCE"] = "Convenience";
    CardLinkedOfferCategory["GAS"] = "Gas";
    CardLinkedOfferCategory["DEPARTMENT_STORES"] = "Department Stores";
    CardLinkedOfferCategory["FOOD_BEVERAGE"] = "Food & Beverage";
    CardLinkedOfferCategory["HEALTH_BEAUTY"] = "Health & Beauty";
    CardLinkedOfferCategory["HOME_GARDEN"] = "Home & Garden";
    CardLinkedOfferCategory["MISCELLANEOUS"] = "Miscellaneous";
    CardLinkedOfferCategory["OCCASIONS_GIFTS"] = "Occasions & Gifts";
    CardLinkedOfferCategory["PETS"] = "Pets";
    CardLinkedOfferCategory["SPORTS_OUTDOORS"] = "Sports & Outdoors";
    CardLinkedOfferCategory["SUPPLIES_SERVICES"] = "Supplies & Services";
    CardLinkedOfferCategory["TRAVEL"] = "Travel";
})(CardLinkedOfferCategory || (exports.CardLinkedOfferCategory = CardLinkedOfferCategory = {}));
var CardLinkedOfferUserRewardType;
(function (CardLinkedOfferUserRewardType) {
    CardLinkedOfferUserRewardType["FLAT"] = "FLAT";
    CardLinkedOfferUserRewardType["PERCENT"] = "PERCENT";
})(CardLinkedOfferUserRewardType || (exports.CardLinkedOfferUserRewardType = CardLinkedOfferUserRewardType = {}));
var CardLinkedOfferPurchaseChannel;
(function (CardLinkedOfferPurchaseChannel) {
    CardLinkedOfferPurchaseChannel["INSTORE"] = "INSTORE";
    CardLinkedOfferPurchaseChannel["ONLINE"] = "ONLINE";
})(CardLinkedOfferPurchaseChannel || (exports.CardLinkedOfferPurchaseChannel = CardLinkedOfferPurchaseChannel = {}));
